import { useState, useEffect } from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Avatar from '@mui/material/Avatar';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Icon from '@mui/material/Icon';
import { useTheme } from '@mui/material/styles';
import Grid from '@mui/material/Grid';
import CircularProgress from '@mui/material/CircularProgress';

interface ServiceDetailProps {
  id: number;
  title: string;
  description: string;
  details: string;
  icon: string;
  image: string;
}

const ServiceDetail = (): JSX.Element => {
  const { id } = useParams<{ id: string }>(); // 从 URL 中获取服务的 id
  const theme = useTheme();

  const [service, setService] = useState<ServiceDetailProps | null>(null);

  const fetchServiceDetail = () => {
    axios
      .get<ServiceDetailProps>(`http://120.46.135.166:8000/services/${id}`, {
        headers: {
          Accept: 'application/json',
        },
      })
      .then((response) => {
        setService(response.data);
      })
      .catch((error) => console.log(error));
  };

  useEffect(() => {
    fetchServiceDetail();
  }, [id]);

  if (!service) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" height="100vh">
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box
      sx={{
        padding: theme.spacing(4),
        backgroundColor: theme.palette.background.default,
        minHeight: '100vh',
      }}
    >
      <Grid container justifyContent="center">
        <Grid item xs={12} md={8}>
          <Card
            sx={{
              display: 'flex',
              flexDirection: { xs: 'column', md: 'row' },
              boxShadow: theme.shadows[3],
              borderRadius: 3,
            }}
          >
            {service.image && (
              <CardMedia
                component="img"
                sx={{ width: { md: '40%' }, height: 'auto' }}
                image={`http://120.46.135.166:8000${service.image}`} // 确保图片路径正确
                alt={service.title}
              />
            )}
            <CardContent sx={{ padding: theme.spacing(4), display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
              <Box display="flex" flexDirection="column" alignItems="center">
                <Avatar
                  sx={{
                    width: 80,
                    height: 80,
                    bgcolor: theme.palette.primary.main,
                    marginBottom: theme.spacing(2),
                  }}
                >
                  <Icon className="material-icons-outlined">{service.icon}</Icon>
                </Avatar>
                <Typography variant="h4" gutterBottom align="center">
                  {service.title}
                </Typography>
                <Typography variant="body1" color={theme.palette.text.secondary} paragraph align="center">
                  {service.description}
                </Typography>
                <Typography variant="body2" color={theme.palette.text.secondary} align="center">
                  {service.details}
                </Typography>
              </Box>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Box>
  );
};

export default ServiceDetail;
